// extracted by mini-css-extract-plugin
export default {"container":"VersioningControl_container__I7fY1","tooltip":"VersioningControl_tooltip__UPK-z","button":"VersioningControl_button__Gu2j3"};